import { DELIVERY_STATES } from '../../../lib/deliveryStates';

// The delivery states a courier retrieval may transition from — «Recuperado» records that the
// mensajero took the parcel from the «buzón». Matched case-insensitively (the wire is lowercase;
// older fixtures are TitleCase). Fail closed: an unrecognized state is not retrievable. Includes
// `non_retrieved` — a real retrieval can follow an empty one — and excludes `collected`, `blocked`,
// `non_collected`, `cancelled` and `retrieved` itself. Eligibility is by STATE alone — deliberately
// no Devolución gate: the legacy gates its whole status modal by transaction type, but the panel
// already dropped that gate for the four «Usuario» actions, and retrieving a stuck devolución is
// exactly this action. Spellings come from the canonical constants (backend-confirmed underscores).
const RETRIEVABLE_STATES = new Set<string>([
  DELIVERY_STATES.stored,
  DELIVERY_STATES.expired,
  DELIVERY_STATES.rejected,
  DELIVERY_STATES.nonRetrieved,
]);

export function isRetrievable(status: string): boolean {
  return RETRIEVABLE_STATES.has(status.toLowerCase());
}
